// Helper function to process tags and handle duplicates
const processTags = (tags) => {
    const tagCounts = new Map();
    return tags.map(tag => {
        const count = tagCounts.get(tag.name) || 0;
        tagCounts.set(tag.name, count + 1);
        return {
            ...tag,
            name: count === 0 ? tag.name : `${tag.name} ${count + 1}`
        };
    });
};

export const HeatmapDataFontSizes = {
    giga: 36,
    big: 32,
    medium: 28,
    small: 26,
    mini: 22
}

// Process the mockTerrains data
export const mockTerrains = [
    {
        terrain: 'ARTS',
        tags: processTags([
            { name: 'PAINTING', radius: 28 },
            { name: 'SCULPTURE', radius: 22 },
            { name: 'DRAWING', radius: 24 },
            { name: 'PHOTOGRAPHY', radius: 20 },
            { name: 'DESIGN', radius: 26 },
            { name: 'MUSIC', radius: 22 },
            { name: 'DANCE', radius: 20 },
            { name: 'THEATRE', radius: 24 },
            { name: 'PAINTING', radius: 28 },
            { name: 'SCULPTURE', radius: 22 },
            { name: 'DRAWING', radius: 24 },
            { name: 'PHOTOGRAPHY', radius: 20 },
            { name: 'DESIGN', radius: 26 },
            { name: 'MUSIC', radius: 22 },
            { name: 'DANCE', radius: 20 },
            { name: 'THEATRE', radius: 24 }
        ])
    },
    {
        terrain: 'MUSIC',
        tags: processTags([
            { name: 'ROCK', radius: 28 },
            { name: 'JAZZ', radius: 22 },
            { name: 'CLASSICAL', radius: 24 },
            { name: 'POP', radius: 20 },
            { name: 'HIP-HOP', radius: 26 },
            { name: 'ELECTRONIC', radius: 22 },
            { name: 'BLUES', radius: 20 },
            { name: 'FOLK', radius: 24 },
            { name: 'ROCK', radius: 28 },
            { name: 'JAZZ', radius: 22 },
            { name: 'CLASSICAL', radius: 24 },
            { name: 'POP', radius: 20 },
            { name: 'HIP-HOP', radius: 26 },
            { name: 'ELECTRONIC', radius: 22 },
            { name: 'BLUES', radius: 20 },
            { name: 'FOLK', radius: 24 }
        ])
    },
    {
        terrain: 'FILM',
        tags: processTags([
            { name: 'ACTION', radius: 28 },
            { name: 'DRAMA', radius: 22 },
            { name: 'COMEDY', radius: 24 },
            { name: 'DOCUMENTARY', radius: 20 },
            { name: 'ANIMATION', radius: 26 },
            { name: 'THRILLER', radius: 22 },
            { name: 'ROMANCE', radius: 20 },
            { name: 'SCI-FI', radius: 24 },
            { name: 'ACTION', radius: 28 },
            { name: 'DRAMA', radius: 22 },
            { name: 'COMEDY', radius: 24 },
            { name: 'DOCUMENTARY', radius: 20 },
            { name: 'ANIMATION', radius: 26 },
            { name: 'THRILLER', radius: 22 },
            { name: 'ROMANCE', radius: 20 },
            { name: 'SCI-FI', radius: 24 }
        ])
    },
    {
        terrain: 'FASHION & DESIGN',
        tags: processTags([
            { name: 'COUTURE', radius: 26 },
            { name: 'STREETWEAR', radius: 22 },
            { name: 'JEWELRY', radius: 20 },
            { name: 'INTERIOR', radius: 24 },
            { name: 'GRAPHIC', radius: 22 },
            { name: 'COUTURE', radius: 26 },
            { name: 'STREETWEAR', radius: 22 },
            { name: 'JEWELRY', radius: 20 },
            { name: 'INTERIOR', radius: 24 },
            { name: 'GRAPHIC', radius: 22 }
        ])
    },
    {
        terrain: 'TECH',
        tags: processTags([
            { name: 'AI', radius: 28 },
            { name: 'WEB', radius: 24 },
            { name: 'MOBILE', radius: 22 },
            { name: 'GAMING', radius: 26 },
            { name: 'ROBOTICS', radius: 20 },
            { name: 'AI', radius: 28 },
            { name: 'WEB', radius: 24 },
            { name: 'MOBILE', radius: 22 },
            { name: 'GAMING', radius: 26 },
            { name: 'ROBOTICS', radius: 20 }
        ])
    },
    {
        terrain: 'SPORT',
        tags: processTags([
            { name: 'FOOTBALL', radius: 28 },
            { name: 'BASKETBALL', radius: 24 },
            { name: 'TENNIS', radius: 22 },
            { name: 'CYCLING', radius: 20 },
            { name: 'SWIMMING', radius: 22 },
            { name: 'FOOTBALL', radius: 28 },
            { name: 'BASKETBALL', radius: 24 },
            { name: 'TENNIS', radius: 22 },
            { name: 'CYCLING', radius: 20 },
            { name: 'SWIMMING', radius: 22 }
        ])
    },
    {
        terrain: 'COMEDY',
        tags: processTags([
            { name: 'STAND-UP', radius: 26 },
            { name: 'IMPROV', radius: 22 },
            { name: 'SATIRE', radius: 20 },
            { name: 'PARODY', radius: 24 },
            { name: 'STAND-UP', radius: 26 },
            { name: 'IMPROV', radius: 22 },
            { name: 'SATIRE', radius: 20 },
            { name: 'PARODY', radius: 24 }
        ])
    },
    {
        terrain: 'LIFESTYLE',
        tags: processTags([
            { name: 'TRAVEL', radius: 26 },
            { name: 'FOOD', radius: 22 },
            { name: 'HEALTH', radius: 20 },
            { name: 'FITNESS', radius: 24 },
            { name: 'TRAVEL', radius: 26 },
            { name: 'FOOD', radius: 22 },
            { name: 'HEALTH', radius: 20 },
            { name: 'FITNESS', radius: 24 }
        ])
    },
    {
        terrain: 'LITERATURE & POETRY',
        tags: processTags([
            { name: 'NOVEL', radius: 26 },
            { name: 'POETRY', radius: 22 },
            { name: 'ESSAY', radius: 20 },
            { name: 'SHORT STORY', radius: 24 },
            { name: 'NOVEL', radius: 26 },
            { name: 'POETRY', radius: 22 },
            { name: 'ESSAY', radius: 20 },
            { name: 'SHORT STORY', radius: 24 }
        ])
    },
    {
        terrain: 'SOCIETIES',
        tags: processTags([
            { name: 'HISTORY', radius: 26 },
            { name: 'PHILOSOPHY', radius: 22 },
            { name: 'POLITICS', radius: 20 },
            { name: 'CULTURE', radius: 24 },
            { name: 'HISTORY', radius: 26 },
            { name: 'PHILOSOPHY', radius: 22 },
            { name: 'POLITICS', radius: 20 },
            { name: 'CULTURE', radius: 24 }
        ])
    },
    {
        terrain: 'DANCE',
        tags: processTags([
            { name: 'BALLET', radius: 26 },
            { name: 'HIP-HOP', radius: 22 },
            { name: 'CONTEMPORARY', radius: 20 },
            { name: 'JAZZ', radius: 24 },
            { name: 'BALLET', radius: 26 },
            { name: 'HIP-HOP', radius: 22 },
            { name: 'CONTEMPORARY', radius: 20 },
            { name: 'JAZZ', radius: 24 }
        ])
    },
    {
        terrain: 'SPIRITUALITIES',
        tags: processTags([
            { name: 'MEDITATION', radius: 26 },
            { name: 'YOGA', radius: 22 },
            { name: 'PHILOSOPHY', radius: 20 },
            { name: 'RELIGION', radius: 24 },
            { name: 'MEDITATION', radius: 26 },
            { name: 'YOGA', radius: 22 },
            { name: 'PHILOSOPHY', radius: 20 },
            { name: 'RELIGION', radius: 24 }
        ])
    },
    {
        terrain: 'VIDEO GAMES',
        tags: processTags([
            { name: 'RPG', radius: 26 },
            { name: 'FPS', radius: 22 },
            { name: 'PUZZLE', radius: 20 },
            { name: 'ADVENTURE', radius: 24 },
            { name: 'RPG', radius: 26 },
            { name: 'FPS', radius: 22 },
            { name: 'PUZZLE', radius: 20 },
            { name: 'ADVENTURE', radius: 24 }
        ])
    },
    {
        terrain: 'PHOTOGRAPHY',
        tags: processTags([
            { name: 'PORTRAIT', radius: 24 },
            { name: 'LANDSCAPE', radius: 22 },
            { name: 'STREET', radius: 20 },
            { name: 'WILDLIFE', radius: 26 },
            { name: 'PORTRAIT', radius: 24 },
            { name: 'LANDSCAPE', radius: 22 },
            { name: 'STREET', radius: 20 },
            { name: 'WILDLIFE', radius: 26 }
        ])
    },
    {
        terrain: 'ARCHITECTURE',
        tags: processTags([
            { name: 'MODERN', radius: 24 },
            { name: 'CLASSICAL', radius: 22 },
            { name: 'URBAN', radius: 20 },
            { name: 'INTERIOR', radius: 26 },
            { name: 'MODERN', radius: 24 },
            { name: 'CLASSICAL', radius: 22 },
            { name: 'URBAN', radius: 20 },
            { name: 'INTERIOR', radius: 26 }
        ])
    },
    {
        terrain: 'CULINARY ARTS',
        tags: processTags([
            { name: 'BAKING', radius: 24 },
            { name: 'GOURMET', radius: 22 },
            { name: 'VEGAN', radius: 20 },
            { name: 'GRILLING', radius: 26 },
            { name: 'BAKING', radius: 24 },
            { name: 'GOURMET', radius: 22 },
            { name: 'VEGAN', radius: 20 },
            { name: 'GRILLING', radius: 26 }
        ])
    },
    {
        terrain: 'SCIENCE',
        tags: processTags([
            { name: 'PHYSICS', radius: 24 },
            { name: 'BIOLOGY', radius: 22 },
            { name: 'CHEMISTRY', radius: 20 },
            { name: 'ASTRONOMY', radius: 26 },
            { name: 'PHYSICS', radius: 24 },
            { name: 'BIOLOGY', radius: 22 },
            { name: 'CHEMISTRY', radius: 20 },
            { name: 'ASTRONOMY', radius: 26 }
        ])
    },
    {
        terrain: 'HISTORY',
        tags: processTags([
            { name: 'ANCIENT', radius: 24 },
            { name: 'MEDIEVAL', radius: 22 },
            { name: 'MODERN', radius: 20 },
            { name: 'CONTEMPORARY', radius: 26 },
            { name: 'ANCIENT', radius: 24 },
            { name: 'MEDIEVAL', radius: 22 },
            { name: 'MODERN', radius: 20 },
            { name: 'CONTEMPORARY', radius: 26 }
        ])
    },
    {
        terrain: 'LANGUAGES',
        tags: processTags([
            { name: 'ENGLISH', radius: 24 },
            { name: 'FRENCH', radius: 22 },
            { name: 'SPANISH', radius: 20 },
            { name: 'MANDARIN', radius: 26 },
            { name: 'ENGLISH', radius: 24 },
            { name: 'FRENCH', radius: 22 },
            { name: 'SPANISH', radius: 20 },
            { name: 'MANDARIN', radius: 26 }
        ])
    },
    {
        terrain: 'PHILOSOPHY',
        tags: processTags([
            { name: 'ETHICS', radius: 24 },
            { name: 'LOGIC', radius: 22 },
            { name: 'METAPHYSICS', radius: 20 },
            { name: 'AESTHETICS', radius: 26 },
            { name: 'ETHICS', radius: 24 },
            { name: 'LOGIC', radius: 22 },
            { name: 'METAPHYSICS', radius: 20 },
            { name: 'AESTHETICS', radius: 26 }
        ])
    },
    {
        terrain: 'TRADITIONS',
        tags: processTags([
            { name: 'FESTIVALS', radius: 24 },
            { name: 'RITUALS', radius: 22 },
            { name: 'CUSTOMS', radius: 20 },
            { name: 'CELEBRATIONS', radius: 26 },
            { name: 'FESTIVALS', radius: 24 },
            { name: 'RITUALS', radius: 22 },
            { name: 'CUSTOMS', radius: 20 },
            { name: 'CELEBRATIONS', radius: 26 }
        ])
    },
    {
        terrain: 'MYTHOLOGY',
        tags: processTags([
            { name: 'GREEK', radius: 24 },
            { name: 'NORSE', radius: 22 },
            { name: 'EGYPTIAN', radius: 20 },
            { name: 'ASIAN', radius: 26 },
            { name: 'GREEK', radius: 24 },
            { name: 'NORSE', radius: 22 },
            { name: 'EGYPTIAN', radius: 20 },
            { name: 'ASIAN', radius: 26 }
        ])
    },
    {
        terrain: 'FOLKLORE',
        tags: processTags([
            { name: 'FAIRY TALES', radius: 24 },
            { name: 'LEGENDS', radius: 22 },
            { name: 'FABLES', radius: 20 },
            { name: 'URBAN LEGENDS', radius: 26 },
            { name: 'FAIRY TALES', radius: 24 },
            { name: 'LEGENDS', radius: 22 },
            { name: 'FABLES', radius: 20 },
            { name: 'URBAN LEGENDS', radius: 26 }
        ])
    },
    {
        terrain: 'EDUCATION',
        tags: processTags([
            { name: 'TEACHING', radius: 24 },
            { name: 'LEARNING', radius: 22 },
            { name: 'RESEARCH', radius: 20 },
            { name: 'INNOVATION', radius: 26 },
            { name: 'TEACHING', radius: 24 },
            { name: 'LEARNING', radius: 22 },
            { name: 'RESEARCH', radius: 20 },
            { name: 'INNOVATION', radius: 26 }
        ])
    },
    {
        terrain: 'MEDIA',
        tags: processTags([
            { name: 'JOURNALISM', radius: 24 },
            { name: 'BROADCAST', radius: 22 },
            { name: 'DIGITAL', radius: 20 },
            { name: 'PRINT', radius: 26 },
            { name: 'JOURNALISM', radius: 24 },
            { name: 'BROADCAST', radius: 22 },
            { name: 'DIGITAL', radius: 20 },
            { name: 'PRINT', radius: 26 }
        ])
    },
    {
        terrain: 'POLITICS',
        tags: processTags([
            { name: 'DEMOCRACY', radius: 24 },
            { name: 'ELECTIONS', radius: 22 },
            { name: 'POLICY', radius: 20 },
            { name: 'DIPLOMACY', radius: 26 },
            { name: 'DEMOCRACY', radius: 24 },
            { name: 'ELECTIONS', radius: 22 },
            { name: 'POLICY', radius: 20 },
            { name: 'DIPLOMACY', radius: 26 }
        ])
    },
    {
        terrain: 'NATURE',
        tags: processTags([
            { name: 'FORESTS', radius: 24 },
            { name: 'OCEANS', radius: 22 },
            { name: 'MOUNTAINS', radius: 20 },
            { name: 'DESERTS', radius: 26 },
            { name: 'FORESTS', radius: 24 },
            { name: 'OCEANS', radius: 22 },
            { name: 'MOUNTAINS', radius: 20 },
            { name: 'DESERTS', radius: 26 }
        ])
    },
    {
        terrain: 'ANIMALS',
        tags: processTags([
            { name: 'MAMMALS', radius: 24 },
            { name: 'BIRDS', radius: 22 },
            { name: 'REPTILES', radius: 20 },
            { name: 'AQUATIC', radius: 26 },
            { name: 'MAMMALS', radius: 24 },
            { name: 'BIRDS', radius: 22 },
            { name: 'REPTILES', radius: 20 },
            { name: 'AQUATIC', radius: 26 }
        ])
    },
    {
        terrain: 'TRAVEL',
        tags: processTags([
            { name: 'ADVENTURE', radius: 24 },
            { name: 'CULTURE', radius: 22 },
            { name: 'NATURE', radius: 20 },
            { name: 'HISTORY', radius: 26 },
            { name: 'ADVENTURE', radius: 24 },
            { name: 'CULTURE', radius: 22 },
            { name: 'NATURE', radius: 20 },
            { name: 'HISTORY', radius: 26 }
        ])
    },
    {
        terrain: 'SOCIAL MEDIA',
        tags: processTags([
            { name: 'NETWORKING', radius: 24 },
            { name: 'CONTENT', radius: 22 },
            { name: 'INFLUENCE', radius: 20 },
            { name: 'TRENDS', radius: 26 },
            { name: 'NETWORKING', radius: 24 },
            { name: 'CONTENT', radius: 22 },
            { name: 'INFLUENCE', radius: 20 },
            { name: 'TRENDS', radius: 26 }
        ])
    },
    {
        terrain: 'FESTIVALS',
        tags: processTags([
            { name: 'MUSIC', radius: 24 },
            { name: 'ART', radius: 22 },
            { name: 'FOOD', radius: 20 },
            { name: 'CULTURE', radius: 26 },
            { name: 'MUSIC', radius: 24 },
            { name: 'ART', radius: 22 },
            { name: 'FOOD', radius: 20 },
            { name: 'CULTURE', radius: 26 }
        ])
    }
];

const getTerrainSizeByAverageRadius = (averageRadius) => {
    if (averageRadius >= 26) return HeatmapDataFontSizes.giga;
    if (averageRadius >= 24) return HeatmapDataFontSizes.big;
    if (averageRadius >= 22) return HeatmapDataFontSizes.medium;
    if (averageRadius >= 20) return HeatmapDataFontSizes.small;
    return HeatmapDataFontSizes.mini;
};

export const mockTerrainsWithRandomRadii = mockTerrains.slice(0, 12).map(terrain => {
    const averageRadius = terrain.tags.reduce((sum, tag) => sum + tag.radius, 0) / terrain.tags.length;
    return {
        ...terrain,
        size: getTerrainSizeByAverageRadius(averageRadius),
        tags: terrain.tags.map(tag => ({
            ...tag,
            radius: Math.floor(Math.random() * 25) + 5, // 5 to 30 inclusive
            hashtags: [
                { name: 'hashtag1', radius: 24 },
                { name: 'hashtag2', radius: 22 },
                { name: 'hashtag3', radius: 20 },
                { name: 'hashtag4', radius: 26 },
                { name: 'hashtag5', radius: 24 },
                { name: 'hashtag6', radius: 22 },
                { name: 'hashtag7', radius: 20 },
                { name: 'hashtag8', radius: 26 }
            ]
        }))
    };
});

const allTagRadii = mockTerrains.flatMap(t => t.tags.map(tag => tag.radius || 22));

export const globalMinRadius = Math.min(...allTagRadii);
export const globalMaxRadius = Math.max(...allTagRadii);

